<template>
<div>
  <div class="mb-sm">
    <!-- Intro -->
    <div class="mb-xxl">
      <div class="content">
        <p class="has-text-weight-bold">Introduction</p>
        <p>
          This workflow will help you submit <b>updated costs or pricing</b> to a merchant partner. To
          submit new products, please submit a
          <router-link class="has-text-info is-underlined" :to="{ name: 'catalog.submit.new' }">new product proposal</router-link>
          instead.
        </p>
        <p>
          Submitting a proposal takes just a few steps, so let's get started.
        </p>
      </div>
    </div>
    <!-- Navigate -->
    <div class="pt-lg">
      <div class="columns is-centered">
        <div class="column">
          <b-button
            type="is-light rounded-lg"
            size="is-medium"
            @click="goBack"
            expanded
            ><b-icon icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button
            type="is-primary rounded-lg"
            size="is-medium"
            expanded
            @click="goForward"
          >Get Started</b-button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['app'])
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'catalog' })
    },
    goForward () {
      this.$emit('navigate', 'Build')
    }
  }
}
</script>
